<template>
  <div class="global-settings">
    <h1 class="title--1 title--unspaced">
      Informations de votre cabinet
    </h1>

    <div class="global-settings__block">
      <div class="settings-block">
        <AddressAndName />
      </div>
    </div>

    <div class="global-settings__block">
      <Contact />
    </div>

    <div class="global-settings__block">
      <DescriptionAndFees />
    </div>

    <div class="global-settings__block">
      <Logo />
    </div>

    <div class="global-settings__block">
      <SocialNetworks />
    </div>
  </div>
</template>

<script>
import {
  AddressAndName,
  Contact,
  Logo,
  SocialNetworks,
  DescriptionAndFees,
} from '../SettingsBlocks';

export default {
  components: {
    AddressAndName,
    Contact,
    Logo,
    SocialNetworks,
    DescriptionAndFees,
  },
};
</script>
